/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneBylineGroup from 'base/components/standalone/BylineGroup';

export const DynamicStandaloneBylineGroup = StandaloneBylineGroup;
export type DynamicStandaloneBylineGroupProps = PropsFromComponent<typeof StandaloneBylineGroup>;

export const DynamicStandaloneBylineGroupWith = (extras: DynamicStandaloneExtras): typeof StandaloneBylineGroup => {
    return function DynamicStandaloneBylineGroup(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'BylineGroup');
        return <StandaloneBylineGroup {...mergeProps({ options: { theme } }, props)} />;
    }
}